import React from "react";
import {
  FaBullhorn,
  FaCopy,
  FaDownload,
  FaPlus,
  FaSync,
  FaUpload,
} from "react-icons/fa";

import FiltersBar from "../components/FiltersBar";
import ProspectionTable from "../components/ProspectionTable";
import DuplicateProspects from "../components/DuplicateProspects";

export default function ProspectsTab({
  loading,
  visibleRows,
  pagination,
  baseParams,

  search,
  setSearch,
  discipline,
  setDiscipline,
  departement,
  setDepartement,
  statuts,
  setStatuts,
  siteStatus,
  setSiteStatus,
  emailMode,
  setEmailMode,
  licMin,
  setLicMin,
  licMax,
  setLicMax,
  sort,
  setSort,
  disciplines,
  departements,

  hideUnsubStatus,
  setHideUnsubStatus,

  selectedIds,
  setSelectedIds,

  onApplyFilters,
  onResetFilters,
  onRefresh,
  onChangeLimit,
  onChangePage,

  onAdd,
  onImport,
  onExport,
  onCopySelectedEmails,
  onEdit,
  onDelete,
  onQuickView,
  onStatusChange,
  onQuickCopy,

  onCreateCampaignFromFilters,
  onCreateCampaignFromSelection,
}) {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_360px] gap-5">
        <div className="rounded-3xl p-4 bg-white dark:bg-slate-900 shadow-sm border border-slate-200 dark:border-slate-800">
          <FiltersBar
            search={search}
            setSearch={setSearch}
            discipline={discipline}
            setDiscipline={setDiscipline}
            departement={departement}
            setDepartement={setDepartement}
            statuts={statuts}
            setStatuts={setStatuts}
            siteStatus={siteStatus}
            setSiteStatus={setSiteStatus}
            emailMode={emailMode}
            setEmailMode={setEmailMode}
            licMin={licMin}
            setLicMin={setLicMin}
            licMax={licMax}
            setLicMax={setLicMax}
            sort={sort}
            setSort={setSort}
            disciplines={disciplines}
            departements={departements}
            onApply={onApplyFilters}
            onReset={onResetFilters}
            limit={pagination.limit}
            setLimit={onChangeLimit}
            total={pagination.total}
            hideUnsubStatus={hideUnsubStatus}
            setHideUnsubStatus={setHideUnsubStatus}
          />
        </div>

        <ProspectsActionsCard
          selectedCount={selectedIds.size}
          total={pagination.total}
          onAdd={onAdd}
          onImport={onImport}
          onExport={onExport}
          onCopySelectedEmails={onCopySelectedEmails}
          onRefresh={onRefresh}
          onCreateCampaignFromFilters={onCreateCampaignFromFilters}
          onCreateCampaignFromSelection={onCreateCampaignFromSelection}
        />
      </div>

      <DuplicateProspects
        rows={visibleRows}
        currentParams={baseParams}
        onEdit={onEdit}
        onDelete={onDelete}
      />

      <div className="rounded-3xl overflow-hidden bg-white dark:bg-slate-900 shadow-sm border border-slate-200 dark:border-slate-800">
        <ProspectionTable
          loading={loading}
          rows={visibleRows}
          sort={sort}
          setSort={setSort}
          onEdit={onEdit}
          onDelete={onDelete}
          onQuickView={onQuickView}
          onStatusChange={onStatusChange}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          onQuickCopy={onQuickCopy}
        />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 p-4 border-t border-slate-100 dark:border-slate-800 text-sm">
          <div className="text-slate-600 dark:text-slate-400">
            Page {pagination.page} / {pagination.pages} — {pagination.total}{" "}
            résultat(s)
          </div>

          <div className="flex items-center gap-2">
            <button
              className="px-3 py-2 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50"
              onClick={() => onChangePage(pagination.page - 1)}
              disabled={pagination.page <= 1}
            >
              ← Précédent
            </button>

            <button
              className="px-3 py-2 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50"
              onClick={() => onChangePage(pagination.page + 1)}
              disabled={pagination.page >= pagination.pages}
            >
              Suivant →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProspectsActionsCard({
  selectedCount,
  total,
  onAdd,
  onImport,
  onExport,
  onCopySelectedEmails,
  onRefresh,
  onCreateCampaignFromFilters,
  onCreateCampaignFromSelection,
}) {
  return (
    <div className="rounded-3xl bg-white dark:bg-slate-900 shadow-sm border border-slate-200 dark:border-slate-800 p-5">
      <div className="font-semibold">Actions rapides</div>

      <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
        Importer, qualifier, copier les emails sélectionnés et préparer vos
        campagnes à partir de vos filtres ou de votre sélection.
      </p>

      <div className="mt-4 grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={onAdd}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 text-white dark:bg-slate-100 dark:text-slate-950 px-3 py-2 text-sm"
        >
          <FaPlus /> Ajouter
        </button>

        <button
          type="button"
          onClick={onImport}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-100 dark:bg-slate-800 px-3 py-2 text-sm"
        >
          <FaUpload /> Import
        </button>

        <button
          type="button"
          onClick={onExport}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-100 dark:bg-slate-800 px-3 py-2 text-sm"
        >
          <FaDownload /> Export
        </button>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-100 dark:bg-slate-800 px-3 py-2 text-sm"
        >
          <FaSync /> Actualiser
        </button>

        <button
          type="button"
          disabled={selectedCount === 0}
          onClick={onCopySelectedEmails}
          className="col-span-2 inline-flex items-center justify-center gap-2 rounded-2xl bg-indigo-600 text-white px-3 py-2 text-sm hover:bg-indigo-700 disabled:opacity-50"
        >
          <FaCopy /> Copier les emails sélectionnés
        </button>
      </div>

      <div className="mt-5 rounded-2xl bg-blue-50 dark:bg-blue-950/30 border border-blue-100 dark:border-blue-900/50 p-4">
        <div className="font-medium text-blue-950 dark:text-blue-100">
          Créer une campagne
        </div>

        <div className="mt-1 text-xs text-blue-800 dark:text-blue-200/80">
          Total filtré : {total} prospect(s) • Sélection : {selectedCount}
        </div>

        <div className="mt-3 space-y-2">
          <button
            type="button"
            onClick={onCreateCampaignFromFilters}
            className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white px-3 py-2 text-sm hover:bg-blue-700"
          >
            <FaBullhorn /> Depuis les filtres
          </button>

          <button
            type="button"
            disabled={selectedCount === 0}
            onClick={onCreateCampaignFromSelection}
            className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-white text-blue-700 border border-blue-200 px-3 py-2 text-sm hover:bg-blue-50 disabled:opacity-50 dark:bg-slate-900 dark:border-blue-900/60 dark:text-blue-200"
          >
            <FaBullhorn /> Depuis la sélection
          </button>
        </div>
      </div>
    </div>
  );
}